import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=980a47a4&scoped=true"
import script from "./Badge.vue?vue&type=script&lang=js"
export * from "./Badge.vue?vue&type=script&lang=js"
import style0 from "./Badge.vue?vue&type=style&index=0&id=980a47a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980a47a4",
  null
  
)

export default component.exports